// see https://docs.google.com/document/d/1lkZKkO9I89kb8_9UaSsNtqSG3PJ-mYa584h50rsvIkU/edit
export const getTotalTasteReviewsCount = ({ structure, flavor }) => {
  const structureReviewsCount = structure
    ? structure.user_structure_count + structure.calculated_structure_count
    : 0;
  const flavorReviewsCount = (flavor || []).reduce(
    (memo, flavorItem) => memo + flavorItem.stats.count,
    0
  );
  return Math.max(structureReviewsCount, flavorReviewsCount);
};
